import { supabase } from '../../../../lib/supabase'

export default function CampaignsTable({ campaigns, onEdit, onRefresh }) {
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this campaign?')) return
    await supabase.from('welfare_campaigns').delete().eq('id', id)
    onRefresh()
  }

  return (
    <div className="flex flex-col gap-4">
      {campaigns.map((campaign) => {
        const percentage = Math.min(
          Math.round((campaign.raised_amount / campaign.target_amount) * 100),
          100
        )
        return (
          <div key={campaign.id} className="bg-gray-50 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-6">
            <div className="flex justify-between items-start gap-4 mb-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2 flex-wrap">
                  <h3 className="font-black text-lg uppercase tracking-tight text-gray-900 dark:text-white">
                    {campaign.title}
                  </h3>
                  <span className={`text-xs font-bold uppercase tracking-widest px-2 py-1 ${
                    campaign.status === 'active'
                      ? 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400'
                      : 'bg-gray-100 dark:bg-white/10 text-gray-400'
                  }`}>
                    {campaign.status}
                  </span>
                </div>
                {campaign.description && (
                  <p className="text-gray-500 text-sm leading-relaxed">{campaign.description}</p>
                )}
              </div>
              <div className="flex gap-3 shrink-0">
                <button onClick={() => onEdit(campaign)} className="text-xs text-green-600 dark:text-green-400 hover:text-green-700 dark:hover:text-green-300 font-bold uppercase tracking-widest transition-colors">
                  Edit
                </button>
                <button onClick={() => handleDelete(campaign.id)} className="text-xs text-red-500 hover:text-red-400 font-bold uppercase tracking-widest transition-colors">
                  Delete
                </button>
              </div>
            </div>

            <div className="bg-gray-200 dark:bg-white/10 h-2 mb-3">
              <div className="bg-green-500 h-2 transition-all" style={{ width: `${percentage}%` }} />
            </div>

            <div className="flex justify-between items-center">
              <span className="text-green-600 dark:text-green-400 font-black text-lg">
                ZMW {campaign.raised_amount.toLocaleString()}
              </span>
              <span className="text-gray-500 text-sm">
                {percentage}% of ZMW {campaign.target_amount.toLocaleString()}
              </span>
            </div>
          </div>
        )
      })}
    </div>
  )
}